import React, { useState, useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import SidebarPaciente from "./SidebarPaciente";
import "../styles/SidebarPaciente.css";

const ProtectedLayoutPaciente = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Check for authentication
  const token = localStorage.getItem("authToken");
  if (!token) {
    return <Navigate to="/" />;
  }

  return (
    <div className={`layout ${isMobile ? 'mobile-layout' : ''}`}>
      <SidebarPaciente />
      <div className="main-content">
        <Outlet />
      </div>
    </div>
  );
};

export default ProtectedLayoutPaciente;
